/* qeslint-disable */

/** *********************** */
// Tweens
/** *********************** */

export type TweenFunction = (amount: number) => number;

export const Tweens: Record<string, TweenFunction> = {
    none: function (amount: number): number {
        return amount * 0;
    },
    linear: function (amount: number): number {
        return amount;
    },
    quadEaseIn: function (amount: number): number {
        return amount * amount;
    },
    quadEaseOut: function (amount: number): number {
        return -amount * (amount - 2);
    },
    quadEaseInOut: function (amount: number): number {
        let amountScaled = amount * 2;

        if (amountScaled < 1) {
            return 0.5 * amountScaled * amountScaled;
        }

        amountScaled -= 1;

        return -0.5 * (amountScaled * (amountScaled - 2) - 1);
    }
};

export const Easing = {
    none: "none",
    linear: "linear",
    quadEaseIn: "quadEaseIn",
    quadEaseOut: "quadEaseOut",
    quadEaseInOut: "quadEaseInOut"
} as const;
